import type { IntegrationName } from "@tellescope/tanstack-query";
import { ReactNode } from "react";
import { DialogSection } from "@tellescope/ui";
import { IntegrationOrbit } from "../../../IntegrationOrbit";

export interface StepWrapperProps {
  selectedIntegrationNames: IntegrationName[];
  highlightedIntegrations: IntegrationName[];
  completedIntegrations?: IntegrationName[];
  children: ReactNode;
}

export const StepWrapper = ({
  selectedIntegrationNames,
  highlightedIntegrations,
  completedIntegrations = [],
  children,
}: StepWrapperProps) => {
  return (
    <DialogSection className="px-8 grid grid-cols-[1fr_2fr] grid-rows-[minmax(0,1fr)] py-0 bg-gray-50 h-[500px] overflow-hidden">
      <IntegrationOrbit
        selectedIntegrations={selectedIntegrationNames}
        highlightedIntegrations={highlightedIntegrations}
        completedIntegrations={completedIntegrations}
      />
      {children}
    </DialogSection>
  );
};
